import script from "./ProjetosComp.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjetosComp.vue?vue&type=script&setup=true&lang=js"

import "./ProjetosComp.vue?vue&type=style&index=0&id=81d1d87e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81d1d87e"]])

export default __exports__